<template>
  <div class="map-container">
    <history-modal v-if="$route.name === 'story'" />
    <div v-if="$route.path === path.public.game" class="scene-wrapper">
      <TiledScene v-if="!$device.isMobile && tilemap" :tilemap="tilemap" />

      <div v-if="$device.isMobile" class="home-bg">
        <transition name="fade">
          <LoaderMobile :loading="isMobileLoading" />
        </transition>

        <transition name="fade-in">
          <MobileBuildingsListFromHomePage v-model="isMobileLoading" />
        </transition>

        <transition name="fade-in">
          <MobileScrollDownInfoBox
            v-model="isMobileLoading"
            :info="$t('mobileScrollUpDownMainLabel')"
            class="bottom-position"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { path } from '~/utils/constants';
import type TiledMap from 'tiled-tmj-typedefs/types/TiledMap';
import halloweenItemRegistry from '~/utils/halloween/halloween-item-registry';

const runtimeConfig = useRuntimeConfig();
const { blockchain } = useEnvs();

const isMobileLoading = ref(true);

definePageMeta({
  middleware: [
    function () {
      if (import.meta.client) {
        const { isMobile, isTablet } = useDevice();
        if (isMobile || isTablet) return setPageLayout('mobile-game-section');
        return setPageLayout('default');
      } else {
        const { $ssrDevice } = useNuxtApp();
        if ($ssrDevice().isMobile) return setPageLayout('mobile-game-section');
        return setPageLayout('default');
      }
    }
  ],
  layout: false
});

const loading = ref<boolean>(false);
const tilemap = ref<TiledMap | null>(null);

onMounted(async () => {
  loading.value = true;
  tilemap.value = await fetch(
    runtimeConfig.public.env === 'prod'
      ? '/assets/new_scenes/Map3_prod.tmj'
      : runtimeConfig.public.env === 'demo'
        ? '/assets/new_scenes/Map3_demo.tmj'
        : '/assets/new_scenes/Map3.tmj'
  ).then((rs) => rs.json());
  loading.value = false;
  halloweenItemRegistry.setup(runtimeConfig, blockchain);

  useUnclaimedModifiers();
});
</script>

<style scoped lang="scss">
.scene-wrapper {
  width: 100%;

  @media screen and (min-width: 767px) {
    height: calc(100dvh - 80px);
  }
}

.fade-in-enter-active {
  transition: opacity 2s linear;
}

.fade-in-enter-from {
  opacity: 0;
}

.fade-in-enter-to {
  opacity: 1;
}
</style>

<style lang="scss">
.buyPackContainer {
  .lot-image-scaled {
    transform: scale(1.1);
    margin-top: 12px;
  }
}

.home-bg {
  background-image: url('~/public/img/loadingOverlay/mountains-blur.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: calc(100dvh - 80px);
  opacity: 0;
  animation: show 1s linear forwards;
  padding: 110px 0;
}

.bottom-position {
  position: absolute;
  z-index: 2;
  width: 100%;
  bottom: 80px;

  @media (max-width: 479px) {
    bottom: 70px;
  }
}

@keyframes show {
  to {
    opacity: 1;
  }
}
</style>
